import { connect } from 'react-redux';
import withRouter from 'react-router/lib/withRouter';
import { withState, compose } from 'recompose';
import FormWrapper from '../components/FormWrapper';
import { getActiveType, isBrandViewActive } from '../../../../auth/selectors';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../modules/infra/feature-flags';

const mapStateToProps = state => ({
  isBrandUser: isBrandViewActive(state),
  isShop: getActiveType(state) === 'shop',
});

const FormWrapperContainer = compose(
  withRouter,
  connect(mapStateToProps),
  withState('page', 'setPage', 0),
  withInjectFeatureFlagsToProps([flagNames.BRAND_TAX_AUTO_SAVE]),
)(FormWrapper);

export default FormWrapperContainer;
